import React from 'react';
import { Col, Row } from 'reactstrap';
import logo from "../assets/governor.png";

export default function ChancellorMessage() {
    return (
        <div className="container mt-5 mb-5">
            <Row className="align-items-start mb-2">
                {/* Image Column */}
                <Col md={3} className="text-center" style={{ marginTop: "6rem" }}>
                    <img
                        src={logo}
                        alt="Chancellor"
                        className="img-fluid rounded shadow-sm"
                        style={{ maxHeight: "250px", objectFit: "cover" }}
                    />
                </Col>

                {/* Message Column */}
                <Col md={9}>
                    {/* Styled Header Box */}
                    <div
                        style={{
                            backgroundColor: "#77236b",
                            padding: "12px 40px",
                            borderRadius: "8px",
                            border: "1px solid #cdd6f3",
                            boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
                            color: "#fff",
                            textAlign: "center",
                            width: "100%",
                            marginBottom: "2rem"
                        }}
                    >
                        <h4 className="fw-bold text-white m-0">कुलाधिपति सन्देश</h4>
                    </div>

                    {/* Chancellor Message Body */}
                    <div
                        style={{
                            textAlign: "justify",
                            lineHeight: "1.9",
                            fontSize: "1.1rem",
                            backgroundColor: "#f9f9f9",
                            padding: "30px 25px",
                            borderRadius: "12px",
                            boxShadow: "0 0 12px rgba(0, 0, 0, 0.12)",
                            marginBottom: "1.5rem",
                        }}
                    >
                        <p style={{ textIndent: '150px', textAlign: 'justify' }}> यह अत्यन्त हर्ष और गौरव का विषय है कि हरियाणा सरकार संस्कृत भाषा के संरक्षण और संवर्धन के लिए दृढ प्रतिज्ञ है।
                            इस संकल्प की पूर्ति हेतु 2018 में हरियाणा सरकार ने कैथल नगर के मून्दड़ी नामक गाँव में महर्षि वाल्मीकि संस्कृत विश्वविद्यालय स्थापित करने का निर्णय लिया।
                            ज्ञान-विज्ञान के संरक्षण, पोषण और पल्लवन तथा संस्कृत भाषा के प्रचार-प्रसार के लिए कृतसंकल्पित यह विश्वविद्यालय, न केवल हरियाणा प्रदेश को अपितु सम्पूर्ण भारत देश को गौरवान्वित करेगा।
                            ऐतिहासिक शहर कैथल में संस्कृत विश्वविद्यालय की स्थापना के लिए सभी कैथलवासियों को बधाई।
                        </p>
                        <p style={{ textIndent: '150px', textAlign: 'justify' }}> हम विश्वविद्यालय परिवार को शुभकामनाएं देते हैं कि यह विश्वविद्यालय निरन्तर प्रगति के पथ पर अग्रसर रहे और अपने विशिष्ट उद्देश्यों को पूरा करने में सफलता प्राप्त करे।
                        </p>
                        <p className="text-end mt-5 mb-0">
                            <strong>महामहिम राज्यपाल प्रो. अशीम कुमार घोष</strong><br />
                            कुलाधिपति
                        </p>
                    </div>
                </Col>
            </Row>
        </div>
    );
}
